import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens'; // TODO: FORM-629 Analytics:
// import {
//   fireOperationalAnalytics,
//   useAnalyticsEvents,
// } from '@atlassian/jira-product-analytics-bridge';

import { StyledBox, StyledText } from '../../../../common/ui/picker/styled';
import messages from './messages';

var ErrorMessage = function ErrorMessage(_ref) {
  var onRetry = _ref.onRetry;
  // const { createAnalyticsEvent } = useAnalyticsEvents();
  var onClick = useCallback(function () {
    onRetry === null || onRetry === void 0 ? void 0 : onRetry(); // fireOperationalAnalytics(
    //   createAnalyticsEvent({}),
    //   'refinementBarSelectRetry clicked',
    // );
  }, [onRetry]);
  return /*#__PURE__*/React.createElement(StyledBox, {
    height: 144
  }, /*#__PURE__*/React.createElement(StyledBox, {
    height: 72,
    iconSize: 72
  }, /*#__PURE__*/React.createElement(ErrorIcon, {
    primaryColor: token('color.icon.subtle', N500),
    label: ""
  })), /*#__PURE__*/React.createElement(StyledText, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.errorMessage)), /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    appearance: "link"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.retryMessage)));
};

export default ErrorMessage;